<template>
  <div class="page">
    <HeaderTop />

    <div class="page_banner">
      <img src="../../assets/pc/banner.png"
           alt="" />
      <!-- <Video @ended="videoEnd" /> -->
      <!-- <swiper ref="mySwiper"
              :options="swiperOptions">
        <swiper-slide>
          <Video @ended="videoEnd" />
        </swiper-slide>
        <swiper-slide><img src="../../assets/pc/banner.png"
               alt="" /></swiper-slide>
        <div class="swiper-pagination"
             slot="pagination"></div>
      </swiper> -->
    </div>

    <div class="page_content">
      <section>
        <div class="page_content_5 pt50">
          <div class="page_content_title">
            <h5 class="mb20">免费获取解决方案</h5>
          </div>
          <div class="method-form">
            <el-form ref="form"
                     :inline="true"
                     :model="formData">
              <el-form-item prop="userName"
                            label="名称">
                <el-input v-model="formData.userName"
                          placeholder="请输入您的称呼"
                          style="width: 360px" />
              </el-form-item>
              <el-form-item prop="mobile"
                            label="电话">
                <el-input v-model="formData.mobile"
                          placeholder="请输入您的电话号码"
                          style="width: 360px" />
              </el-form-item>
              <el-form-item>
                <el-button id="pcMethod"
                           type="success"
                           @click="handleCall"
                           style="width: 160px"
                           data-agl-cvt="5">立即提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </section>
      <!-- <section>
        <div class="page_content_1">
          <div class="page_content_title">
            <img src="../../assets/pc/background.png" alt="" />
            <div class="page_content_title_h6">
              <h6>方案背景</h6>
              <p>—— 政策指引 构建校内课后托管新模式 ——</p>
            </div>
          </div>

          <img src="../../assets/pc/background-1.png" alt="" />
        </div>
      </section> -->
      <!-- 
      <section>
        <div class="page_content_2">
          <div class="page_content_title">
            <img src="../../assets/pc/keyword.png" alt="" />
            <div class="page_content_title_h6">
              <h6>关键字解读</h6>
            </div>
          </div>

          <img src="../../assets/pc/keyword-1.png" alt="" />
        </div>
      </section> -->
      <section>
        <div class="page_content_3">
          <div class="page_content_title">
            <img src="../../assets/pc/overview.png"
                 alt="" />
            <div class="page_content_title_h6">
              <h6>方案概述</h6>
              <p>—— 解决中小学生课后托管最后一公里难题 ——</p>
            </div>
          </div>

          <div class="page_content_main">
            <div class="page_content_main_img">
              <img src="../../assets/pc/overview-1.png"
                   alt="" />
            </div>
            <div class="page_content_main_text text-indent">
              430托管学堂依托大数据、物联网等技术手段，根据国家校内课后服务工作的政策指示，通过局校一体化管控及第三服务机构开展校内课后服务工作，打造规范高效的特色区域课后托管服务平台。搭建教育主管部门与社会培训机构、学校、家长、学生之间的桥梁，实现机构审核、课程上架、选课、打卡考勤、营养配餐等环节的业务闭环。信息高效流转，减轻学校、机构的负担，帮助教育主管部门进行更有效的监管。
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="page_content_4">
          <div class="page_content_title">
            <img src="../../assets/pc/framework.png"
                 alt="" />
            <div class="page_content_title_h6">
              <h6>方案架构</h6>
              <p>—— 校内课后托管解决方案整体架构 ——</p>
            </div>
          </div>

          <p class="mb10 textCenter">
            <span class="mr15 font28">1个平台</span>
            <span class="mr15 font28">4个中心</span>
            <span class="mr15 font28">6个服务对象</span>
            <span class="mr15 font28">解决5大难题</span>
          </p>

          <img src="../../assets/pc/framework-1.png"
               alt="" />
        </div>
      </section>

      <section>
        <div class="page_content_5">
          <div class="page_content_title">
            <img src="../../assets/pc/advantage.png"
                 alt="" />
            <div class="page_content_title_h6">
              <h6>核心优势</h6>
              <p>—— 局校一体化 ——</p>
            </div>
          </div>

          <img src="../../assets/pc/advantage-1.png"
               alt="" />
        </div>
      </section>

      <section>
        <div class="page_content_6">
          <div class="page_content_title">
            <img src="../../assets/pc/application.png"
                 alt="" />
            <div class="page_content_title_h6">
              <h6>应用场景</h6>
              <p>—— 中小学生校内课后托管解决方案整体架构 ——</p>
            </div>
          </div>

          <div>
            <div class="page_content_main mb20"
                 v-for="(app, i) of applications"
                 :key="i">
              <div class="page_content_main_img">
                <img :src="app.img"
                     alt="" />
              </div>
              <div class="page_content_main_text">
                <div class="page_content_main_text_title">{{ app.title }}</div>
                <div class="page_content_main_text_dd">
                  <p v-for="(text, j) of app.content"
                     :key="`text${j}`">{{ text }}</p>
                </div>
                <div class="page_content_main_text_tags">
                  <span v-for="tag in app.tags"
                        :key="tag">{{ tag }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mb20">
        <div class="page_content_5 pt20">
          <div class="page_content_title">
            <h5 class="mb20">试用申请</h5>
          </div>
          <div class="form">
            <el-form ref="form"
                     :model="formData">
              <el-form-item prop="userName"
                            label-width="40px"
                            label="名称">
                <el-input v-model="formData.userName"
                          placeholder="请输入您的称呼" />
              </el-form-item>
              <el-form-item prop="mobile"
                            label-width="40px"
                            label="电话">
                <el-input v-model="formData.mobile"
                          placeholder="请输入您的电话号码" />
              </el-form-item>
              <el-form-item>
                <el-button id="pcSubmit"
                           type="success"
                           @click="handleCall"
                           style="width: 100%"
                           round
                           data-agl-cvt="5">立即提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </section>
      <div class="flex-center mb60">
        <span class="mr50">地址：广州市黄埔区科学大道239号A1栋10-11层</span>
        <span class="mr30">Copyright © 广东宜教通教育有限公司</span>
        <span>粤ICP备15067984号</span>
      </div>
    </div>

    <footer class="page_footer">
      <div class="page_footer_content">
        <span>面向全国区、县、市招募合作伙伴</span>
        <CallPhone is-icon />
        <button id="pcTest"
                @click="dialogVisible = true"
                round
                data-agl-cvt="1">申请试用</button>
        <div class="qrcode"
             @mouseover="
            () => {
              active = true
            }
          "
             @mouseout="
            () => {
              active = false
            }
          ">
          <img src="@/assets/pc/icon-wechat.png"
               alt="" />
        </div>
        <div v-show="active"
             class="qrcode-active">
          <img src="@/assets/common/image/qrcode.jpg"
               alt="" />
        </div>
      </div>
      <!-- <img src="@/assets/common/image/icon-qrcode.jpg" alt="" />
      <div v-show="active" class="qrcode-active">
        <img src="@/assets/common/image/qrcode.jpg" alt="" />
      </div> -->
      <!-- <div class="page_footer-left">
        <img src="@/assets/pc/footer-pic.png" alt="" />
      </div>
      <div class="page_footer-right">
        <div class="page_footer-right-top">
          <span>面向全国区、县、市招募合作伙伴</span>
          <CallPhone is-icon id="phone" />
        </div>
        <div class="page_footer-right-bottom">
          <input type="number" v-model="phoneNumber" id="number" placeholder="请输入您的电话号码，我们立即联系您！" size="11" />
          <button id="message" @click="handleCall">立即联系</button>
          <a href="https://p.qiao.baidu.com/cps/chat?siteId=16995448&userId=33879454&siteToken=98e786550f55134da7b3d1b90e4493ba" target="_blank">
            <button style="border-radius: 4px" id="kefu"><img src="@/assets/common/image/icon-kefu.png" alt="" /> 在线客服</button>
          </a>
          <div
            class="qrcode"
            @mouseover="
              () => {
                active = true
              }
            "
            @mouseout="
              () => {
                active = false
              }
            "
          >
            <img src="@/assets/common/image/icon-qrcode.jpg" alt="" />
          </div>
        </div>
        <div v-show="active" class="qrcode-active">
          <img src="@/assets/common/image/qrcode.jpg" alt="" />
        </div>
      </div> -->
    </footer>
    <el-dialog title="申请试用"
               :visible.sync="dialogVisible"
               width="386px"
               :before-close="handleClose"
               center>
      <el-form ref="form"
               label-position="top"
               label-width="80px"
               :model="formData">
        <el-form-item prop="userName"
                      label="名称"
                      :rules="[{ required: true, message: '请输入称呼' }]">
          <el-input v-model="formData.userName"
                    placeholder="请输入您的称呼" />
        </el-form-item>
        <el-form-item prop="mobile"
                      label="电话"
                      :rules="[{ required: true, message: '请输入电话号码' }]">
          <el-input v-model="formData.mobile"
                    placeholder="请输入您的电话号码" />
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button id="pcModalData"
                   type="success"
                   style="width: 100%"
                   @click="handleCall"
                   round
                   data-agl-cvt="5">立即提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Contant from '../../const/index.js'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
// import Video from './component/video.vue'
import { isPhoneNumber } from '@/utils'
export default {
  components: {
    // swiper,
    // swiperSlide,
    // Video,
  },
  data() {
    return {
      applications: Contant.applications,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      active: false,
      phoneNumber: '',
      dialogVisible: false,
      formData: {
        userName: '',
        mobile: ''
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    videoEnd() {
      this.autoplay = false
      this.swiper.autoplay.start()
    },
    handleCall() {
      if (isPhoneNumber(this.formData.mobile)) {
        this.$axios
          .post(
            '/train/nzp-train-acts-server/rest/fbck/feedback/save_feedback',
            { ...this.formData }
          )
          .then(res => {
            if (res.data.data) {
              this.$toast('已为您记录，稍后我们会联系您，请注意接听！')
              window._agl && window._agl.push(['track', ['success', { t: 3 }]])
              this.dialogVisible = false
              this.$refs.form.resetFields()
            }
          })
          .catch(err => {
            console.error(err)
          })
      } else {
        this.$toast('请输入合法的手机号')
        this.formData.mobile = ''
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./index.less');
/deep/ .el-form-item {
  margin-bottom: 40px;
}
.method-form {
  width: 1000px;
  margin: 0 auto;
}
</style>

